import { useUserProfile } from "@/api/Users";
import { CompetenceChip } from "@/components/Chips/CompetenceChip";
import type {
  IMedicalCompetence,
  IScheduledShift,
} from "@medoma/models/shifts";
import { shiftName } from "@medoma/models/shifts";

export const AssignedShiftChip = ({
  shift,
  medicalCompetence,
  onRemove,
  size = "medium",
  disabled = false,
}: {
  shift: IScheduledShift;
  medicalCompetence: IMedicalCompetence;
  onRemove?: () => void;
  disabled?: boolean;
} & Pick<Parameters<typeof CompetenceChip>[0], "size">) => {
  const { countryCode } = useUserProfile();
  const content = shiftName(
    {
      employee: shift.employee,
      competence: medicalCompetence,
    },
    {
      competenceFormat: "abbreviated",
      countryCode,
      viewer: "colleague",
    },
  );

  return (
    <CompetenceChip
      competence={medicalCompetence}
      state="assigned"
      content={content}
      onRemove={onRemove}
      size={size}
      disabled={disabled}
    />
  );
};
